import React from "react";
import { Card, CardBody, Spinner } from "reactstrap";
import { useMonthlyUsers } from "../../Hooks/useMonthlyUsers";

import { formatNumber } from "../../utils/formatNumber";

const UsersSummaryCard = ({ province, city }) => {

    const { rows, isLoading } = useMonthlyUsers(3, province, city);

    // Se mapea a las claves que ya usaba la tabla, para no tocar el markup.
    const data = rows.map((row) => ({
        month: row.month,
        newUsers: formatNumber(row.new_users),
        activeUsers: formatNumber(row.active_users),
        retention: row.activation_percentage !== null &&
                   row.activation_percentage !== undefined
            ? `${row.activation_percentage}%`
            : "—"
    }));

    return (

        <Card className="border-0 shadow-sm w-100">

            <CardBody className="p-4">

                <h5
                    className="fw-bold mb-4"
                    style={{
                        fontSize: 17,
                        color: "#101828"
                    }}
                >
                    Resumen de Usuarios
                </h5>


                <div
                    className="d-grid mb-3"
                    style={{
                        gridTemplateColumns: "1fr 1fr 1fr .8fr",
                        fontSize: 12,
                        color: "#98A2B3",
                        fontWeight: 600
                    }}
                >

                    <div>Mes</div>

                    <div className="text-end">
                        Nuevos
                    </div>

                    <div className="text-end">
                        Activos
                    </div>

                    <div className="text-end">
                        % Conv.
                    </div>

                </div>

                {isLoading && (
                    <div className="text-center py-4">
                        <Spinner size="sm" color="primary" />
                    </div>
                )}

                {!isLoading && !data.length && (
                    <div className="text-center py-4" style={{ color: "#98A2B3", fontSize: 13 }}>
                        Sin datos de usuarios para el período.
                    </div>
                )}

                {
                    data.map((item, index) => (

                        <div
                            key={index}
                            className="d-grid align-items-center py-3"
                            style={{
                                gridTemplateColumns: "1fr 1fr 1fr .8fr",
                                borderBottom:
                                    index !== data.length - 1
                                        ? "1px solid #F2F4F7"
                                        : "none"
                            }}
                        >

                            <div
                                style={{
                                    color: "#344054",
                                    fontWeight: 500,
                                    fontSize: 14
                                }}
                            >
                                {item.month}
                            </div>

                            <div
                                className="text-end"
                                style={{
                                    color: "#667085",
                                    fontSize: 14
                                }}
                            >
                                {item.newUsers}
                            </div>

                            <div
                                className="text-end"
                                style={{
                                    color: "#667085",
                                    fontSize: 14
                                }}
                            >
                                {item.activeUsers}
                            </div>

                            <div
                                className="text-end"
                                style={{
                                    color: "#12B76A",
                                    fontWeight: 700,
                                    fontSize: 14
                                }}
                            >
                                ↑ {item.retention}
                            </div>

                        </div>

                    ))
                }

            </CardBody>

        </Card>

    );

};

export default UsersSummaryCard;